import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Container, Flex, Grid } from '@chakra-ui/react';
import { formatDataTestId } from '@whitbread-eos/utils';
import Logo from '../../Logo';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StaticHeaderComponent() {
  var baseDataTestId = 'StaticHeader';
  return _jsx(Box, _objectSpread(_objectSpread({}, customHeaderWrapperStyles), {}, {
    "data-testid": formatDataTestId(baseDataTestId, 'Wrapper-Error'),
    children: _jsx(Container, _objectSpread(_objectSpread({}, containerWrapperStyles), {}, {
      children: _jsx(Grid, _objectSpread(_objectSpread({}, contentStyles), {}, {
        sx: {
          '@media print': {
            py: 'sm'
          }
        },
        children: _jsx(Flex, _objectSpread(_objectSpread({}, containerLogoStyle), {}, {
          "data-testid": formatDataTestId(baseDataTestId, 'Logo'),
          children: _jsx(Logo, {})
        }))
      }))
    }))
  }));
}
var customHeaderWrapperStyles = {
  w: 'var(--chakra-sizes-full)',
  backgroundColor: 'var(--chakra-colors-baseWhite)',
  boxShadow: '0 0.125rem 0.75rem var(--chakra-colors-lightGrey2)',
  h: {
    mobile: 'var(--chakra-space-4xl)',
    lg: 'var(--chakra-space-6xl)'
  }
};
export var contentStyles = {
  w: 'var(--chakra-sizes-full)',
  templateColumns: 'auto 1fr',
  alignItems: 'center'
};
export var containerWrapperStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxW: 'var(--chakra-space-breakpoint-xl)',
  h: 'var(--chakra-sizes-full)',
  pl: {
    mobile: 'md',
    xs: '5',
    sm: 'md',
    md: 'lg',
    lg: '7',
    xl: '4.125rem'
  },
  pr: {
    mobile: 'md',
    md: '1.688rem',
    xl: '5xl'
  }
};
export var containerLogoStyle = {
  justifyContent: 'center',
  alignItems: 'center'
};